/* ============================================================
 * Brindle Calm ADV BR02 — Advertorial landing script
 * Lightweight: only entrance fade + smooth scroll for #offer
 * anchor. No cart logic — bundle CTAs are plain <a href> links
 * that redirect to the sales page.
 * ============================================================ */
(function () {
  'use strict';
  if (window.__brindleCalmAdvBR02Loaded) return;
  window.__brindleCalmAdvBR02Loaded = true;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function initEntranceFade() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // The .bcadvbr02-fade class already has the CSS animation; nothing to do
    // unless we want to chain extra reveals on scroll. Leaving as a hook.
  }

  function initSmoothScroll() {
    // Anchor links inside the advertorial scope: handle scroll with header offset
    $$('.bcadvbr02-scope a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href || href === '#' || href.length < 2) return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Update URL without jumping
        try { history.pushState(null, '', href); } catch (err) {}
      });
    });
  }

  function initOfferSelector() {
    var cards = $$('[data-bcadvbr02-bundle-card]');
    if (!cards.length) return;
    function highlight(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      if (card) {
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
      }
    }
    cards.forEach(function (card) {
      function handle(e) {
        // Let clicks on the inner CTA link navigate normally — only intercept clicks
        // on the empty card area to toggle the selected state.
        if (e && e.target && e.target.closest && e.target.closest('[data-bcadvbr02-bundle-cta]')) return;
        highlight(card);
      }
      card.addEventListener('click', handle);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); highlight(card); }
      });
    });
  }

  function init() {
    var root = $('.bcadvbr02-scope');
    if (!root) return;
    initEntranceFade();
    initSmoothScroll();
    initOfferSelector();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
